class DropdownSelect extends HTMLElement {
  constructor() {
    super();

    // Keep references to your elements
    this.inputLabel = this.querySelector(`#${this.dataset.inputLabel}`);
    this.inputId = this.querySelector(`#${this.dataset.inputId}`);
    this.imageVariant = this.querySelector(".image-variant");
    this.overlay = this.querySelector(".overlay");

    this.optionsList = this.querySelector(`#${this.dataset.optionsList}`);
    this.otherDropdownSelect = this.querySelectorAll("dropdown-select");
    this.optionInputs = this.querySelectorAll("input[type=radio]");
    this.index = this.dataset.index;

    // Bind event handlers so 'this' remains correct
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    this.addEventListener("click", this.toggleDropdown.bind(this));
    this.overlay.addEventListener("click", (event) => {
      // Stop the event from bubbling to the parent
      event.stopPropagation();

      this.closeDropdown();
    });

    this.optionInputs.forEach((item) => {
      item.addEventListener("change", this.handleChange.bind(this));
    });
  }

  /**
   * Called each time the element is appended into a document-connected element.
   */
  connectedCallback() {
    // Listen for clicks anywhere in the document
    document.addEventListener("click", this.handleDocumentClick);
  }

  /**
   * Called each time the element is disconnected from the document
   */
  disconnectedCallback() {
    // Cleanup the listener to avoid memory leaks
    document.removeEventListener("click", this.handleDocumentClick);
  }

  /**
   * Closes the dropdown if the user clicks outside of it.
   * @param {MouseEvent} e
   */
  handleDocumentClick(e) {
    // If the click target is not within this dropdown-select, close it
    if (!this.contains(e.target)) {
      this.closeDropdown();
    }
  }

  /**
   * Updates the input value with the label of the selected option and closes the dropdown.
   */
  handleChange(e) {
    this.inputLabel.value = e.currentTarget.dataset.label;
    this.inputLabel.classList.add("tw-pl-[50px]");
    this.inputLabel.classList.remove("tw-pl-[15px]");
    this.inputLabel.style.backgroundColor = "#ecf9ff";
    this.inputLabel.style.borderColor = "#48bdf1";
    this.inputId.value = e.currentTarget.value;

    this.imageVariant.src = e.currentTarget.dataset.image;
    this.imageVariant.alt = e.currentTarget.dataset.label;
    this.imageVariant.classList.remove("tw-hidden");
    const NoOfBoxes = parseInt(
      document
        .querySelector(".bundle-option.selected")
        ?.getAttribute("data-bundle-size") || "1",
      10
    );
    if (window.innerWidth < 769) {
      if (e.currentTarget.nextElementSibling.querySelector(".star-text")) {
        // Grab or create the custom-label element
        let customLabel =
          this.imageVariant.parentElement.parentElement.querySelector(
            ".custom-label"
          );

        // If .custom-label doesn't exist yet, create it and append it
        if (!customLabel) {
          customLabel = document.createElement("div");
          customLabel.classList.add("custom-label");
          // Append wherever makes sense in your DOM structure:
          // e.g., right under the parent element
          this.imageVariant.parentElement.parentElement.appendChild(
            customLabel
          );
        }

        // Now that we have a custom-label, show it and set its text
        customLabel.classList.remove("custom-label-hidden");
        customLabel.innerHTML =
          e.currentTarget.nextElementSibling.querySelector(
            ".star-text"
          ).innerHTML;

        e.currentTarget.nextElementSibling
          .querySelector(".star-text")
          .classList.forEach((cls) => {
            if (!customLabel.classList.contains(cls)) {
              customLabel.classList.add(cls);
            }
          });
      } else {
        // If .star-text does NOT exist, we can still ensure we have
        // a .custom-label in place (maybe empty or hidden).
        let customLabel =
          this.imageVariant.parentElement.parentElement.querySelector(
            ".custom-label"
          );

        // If it doesn't exist, create it (empty) so it’s there if you need it later
        if (!customLabel) {
          customLabel = document.createElement("div");
          customLabel.classList.add("custom-label");
          // You might want to hide it by default:
          customLabel.classList.add("custom-label-hidden");
          this.imageVariant.parentElement.parentElement.appendChild(
            customLabel
          );
        } else {
          // Or if it does exist, just hide it (or make it empty).
          customLabel.classList.add("custom-label-hidden");
        }
      }
    } else {
      if (NoOfBoxes == 1) {
        if (e.currentTarget.nextElementSibling.querySelector(".star-text")) {
          // Grab or create the custom-label element
          let customLabel =
            this.imageVariant.parentElement.parentElement.querySelector(
              ".custom-label"
            );

          // If .custom-label doesn't exist yet, create it and append it
          if (!customLabel) {
            customLabel = document.createElement("div");
            customLabel.classList.add("custom-label");
            // Append wherever makes sense in your DOM structure:
            // e.g., right under the parent element
            this.imageVariant.parentElement.parentElement.appendChild(
              customLabel
            );
          }

          // Now that we have a custom-label, show it and set its text
          customLabel.classList.remove("custom-label-hidden");
          customLabel.innerHTML =
            e.currentTarget.nextElementSibling.querySelector(
              ".star-text"
            ).innerHTML;

          e.currentTarget.nextElementSibling
            .querySelector(".star-text")
            .classList.forEach((cls) => {
              if (!customLabel.classList.contains(cls)) {
                customLabel.classList.add(cls);
              }
            });
        } else {
          // If .star-text does NOT exist, we can still ensure we have
          // a .custom-label in place (maybe empty or hidden).
          let customLabel =
            this.imageVariant.parentElement.parentElement.querySelector(
              ".custom-label"
            );

          // If it doesn't exist, create it (empty) so it’s there if you need it later
          if (!customLabel) {
            customLabel = document.createElement("div");
            customLabel.classList.add("custom-label");
            // You might want to hide it by default:
            customLabel.classList.add("custom-label-hidden");
            this.imageVariant.parentElement.parentElement.appendChild(
              customLabel
            );
          } else {
            // Or if it does exist, just hide it (or make it empty).
            customLabel.classList.add("custom-label-hidden");
          }
        }
      }
    }

    this.closeDropdown();

    const variantInputId = document.querySelector(
      `#${this.dataset.variantInputId}`
    );

    if (variantInputId) {
      variantInputId.value = e.currentTarget.value.split("*")[0];
    }
  }

  resetValue(size = 1) {
    if (+this.index > size) {
      this.inputLabel.value = `Box ${this.index}`;
      this.inputLabel.classList.remove("tw-pl-[40px]");
      this.inputId.value = "";
      this.imageVariant.classList.add("tw-hidden");
    }
  }

  toggleDropdown() {
    this.resetOtherDropdownSelect();

    this.classList.toggle("open");
    this.optionsList.classList.toggle("tw-opacity-0");
    this.optionsList.classList.toggle("tw-opacity-1");
    this.optionsList.classList.toggle("-tw-translate-y-4");
    this.optionsList.classList.toggle("tw-translate-y-0");
    this.optionsList.classList.toggle("tw-invisible");
    this.optionsList.classList.toggle("tw-visible");
  }

  closeDropdown() {
    this.classList.remove("open");
    this.optionsList.classList.add("tw-opacity-0");
    this.optionsList.classList.remove("tw-opacity-1");
    this.optionsList.classList.add("-tw-translate-y-4");
    this.optionsList.classList.remove("tw-translate-y-0");
    this.optionsList.classList.add("tw-invisible");
    this.optionsList.classList.remove("tw-visible");
  }

  resetOtherDropdownSelect() {
    this.otherDropdownSelect.forEach((item) => {
      item.classList.remove("open");
      item.optionsList.classList.add("tw-opacity-0");
      item.optionsList.classList.remove("tw-opacity-1");
      item.optionsList.classList.add("-tw-translate-y-4");
      item.optionsList.classList.remove("tw-translate-y-0");
      item.optionsList.classList.add("tw-invisible");
      item.optionsList.classList.remove("tw-visible");
    });
  }
}

customElements.define("dropdown-select", DropdownSelect);